import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 懒加载路由，提升性能
const showDisplay = () => import('../views/show/Display')
const showDisplay2 = () => import('../views/show/Display2')
const showMore = () => import('../views/show/More')
const EntInfo = () => import('../views/ent/EntInfo')
const EntAdd = () => import('../views/ent/EntAdd')
const EntList = () => import('../views/ent/EntList')
const Ent2Info = () => import('../views/ent2/EntInfo')
const Ent2Add = () => import('../views/ent2/EntAdd')
const Ent2List = () => import('../views/ent2/EntList')
const MobileEnlist = () => import('../views/mobile/Enlist')
const MobileRegistered = () => import('../views/mobile/Registered')
const MobileAbnormal = () => import('../views/mobile/Abnormal')
const MobileSuccess = () => import('../views/mobile/Success')
const UserCard = () => import('../views/UserCenter/Card')

const routes = [
  {
    path: '/',
    redirect: '/show/map'
  },
  {
    path: '/show/map',
    name: 'showDisplay',
    component: showDisplay
  },
  {
    path: '/show/mapbj',
    name: 'showDisplay2',
    component: showDisplay2
  },
  {
    path: '/show/More',
    name: 'showMore',
    component: showMore
  },
  {
    path: '/ent/info',
    name: 'entInfo',
    component: EntInfo
  },
  {
    path: '/ent/add',
    name: 'entAdd',
    component: EntAdd
  },
  {
    path: '/ent/list',
    name: 'entList',
    component: EntList
  },
  {
    path: '/bjent/info',
    name: 'ent2Info',
    component: Ent2Info
  },
  {
    path: '/bjent/add',
    name: 'ent2Add',
    component: Ent2Add
  },
  {
    path: '/bjent/list',
    name: 'ent2List',
    component: Ent2List
  },
  {
    path: '/mobile/enlist',
    name: 'mobileEnlist',
    component: MobileEnlist
  },
  {
    path: '/mobile/registered',
    name: 'mobileRegistered',
    component: MobileRegistered
  },
  {
    path: '/mobile/abnormal',
    name: 'mobileAbnormal',
    component: MobileAbnormal
  },
  {
    path: '/mobile/success',
    name: 'mobileSuccess',
    component: MobileSuccess
  },
  {
    path: '/Card',
    name: 'UserCard',
    component: UserCard
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
